import { appRoutes } from 'features/app/routes/paths';
import { IdType } from 'ts/IdType';

export const myGiftCardsPaths = Object.freeze({
  static: {
    root: `${appRoutes.static.root}/my-gift-cards`,
    card: `${appRoutes.static.root}/my-gift-cards/:cardId`,
  },
  dynamic: {
    card: (cardId: IdType) => `${appRoutes.static.root}/my-gift-cards/${cardId}`,
  },
});
